<template>
  <div>
    <template v-if="this.$route.query.orderType!=='purchaseSonOrder'">
      <OrderAccount
        v-if="newCalculationOpenSwitch"
        :orderId="orderId"
        @orderAccountSaveSuccess="handleOrderAccountSaveSuccess"
        @orderAccountSubmitSuccess="handleOrderAccountSubmitSuccess"
        @orderAccountSubmitFailed="handleOrderAccountSubmitFailed"
        @orderAccountCancel="handleOrderAccountCancel"
      />
      <NoDataPage v-else></NoDataPage>
    </template>
    <exitCarInfo v-else/>
  </div>
</template>
<script>
import OrderAccount from '@/bizComponents/OrderAccount/index.vue'
import NoDataPage from '@/components/NoDataPage/index.vue'
import exitCarInfo from '@/pages/carsService/purchaseOrder/list/components/exitCarInfo.vue'

export default {
  components: {
    OrderAccount,
    NoDataPage,
    exitCarInfo,
  },
  props: ['orderId', 'newCalculationOpenSwitch'],
  data() {
    return {
      state: null,
    }
  },
  methods: {
    handleOrderAccountSaveSuccess() {
      setTimeout(() => {
        this.$router.push('/workbench/rentOrder/list')
      }, 1200)
    },
    handleOrderAccountSubmitSuccess({ needDingTalkApprove }) {
      const path = '/workbench/rentOrder/detail'
      const query = {
        id: this.orderId,
        type: 8,
      }
      // 如果是钉钉审批流不进行跳转，只更新当前页面状态
      if (!needDingTalkApprove) this.$router.push({ path, query })
      this.$nextTick(() => {
        window.location.reload()
      })
    },
    handleOrderAccountSubmitFailed({ errorCode }) {
      if (errorCode === 24012) {
        // 网约钱包支付提示
        this.$confirm('有正在进行中的网约钱包支付,可等待网约钱包支付完成后再进行核算或手动终止', '提示', {
          confirmButtonText: '去终止',
          cancelButtonText: '取消',
        }).then(() => {
          this.$router.push({
            path: '/finance/withholdPlanList',
          })
        })
      } else if (errorCode === 24013) {
        // 支付宝支付提示
        this.$alert('有正在进行中的支付宝支付,请完成支付宝支付后再进行核算', '提示', {
          confirmButtonText: '关闭',
          callback: () => null,
        })
      }
    },
    handleOrderAccountCancel() {
      this.$refreshBack(false)
    },
  },
  created() {
    this.state = Number(this.$route.query.state)
  },
}
</script>
